module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop4-b717854a9ee55a811f0a102400a136ab.jpg";